import { Box, SanityRichText } from '@tishman/components';
import React from 'react';

import { LinkWithArrowLeftCorner } from './LinkWithArrowLeftCorner';

import type { Block } from '@sanity/block-content-to-react';

type TLink = {
  text: string;
  url: string;
};

type TPrivateEventsHeroVenueDetails = {
  blocks?: Queries.SanityBlock[];
  last: boolean;
  links?: TLink[];
  openInNewWindow?: boolean;
  type?: 'default' | 'venue-category' | 'venue-detail';
};

export const PrivateEventsHeroVenueDetails = ({
  blocks,
  last,
  links,
  openInNewWindow,
  type,
}: TPrivateEventsHeroVenueDetails) => {
  const richTextBlocks = blocks?.map((block) => ({
    ...block,
    markDefs: (block as any).markDefs || [],
  }));

  return (
    <Box
      sx={{
        'marginBottom': [last ? '8px' : '40px', '52px'],
        '& p': {
          fontSize: type === 'venue-category' ? ['16px', 4] : 4,
          lineHeight: '1.6',
        },
        '& h2': {
          fontSize: type === 'venue-category' ? ['16px', '24px'] : '24px',
          letterSpacing: [2, '-0.5px'],
        },
        '& h3': {
          fontSize: type === 'venue-category' ? ['16px', '24px'] : '24px',
          letterSpacing: [2, '-0.5px'],
          marginBottom: 0,
        },
      }}
    >
      {richTextBlocks && (
        <SanityRichText blocks={richTextBlocks as unknown as Block[]} />
      )}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '26px',
          marginTop: '12px',
          flexDirection: ['row'],
        }}
      >
        {links
          ?.filter((link) => !!link.text)
          .map((link) => (
            <LinkWithArrowLeftCorner
              key={link.url}
              openInNewWindow={openInNewWindow}
              text={link.text || ''}
              url={link.url || ''}
            />
          ))}
      </Box>
    </Box>
  );
};
